import { render } from "./CardPayments.vue?vue&type=template&id=425f4c50"
import script from "./CardPayments.vue?vue&type=script&lang=js"
export * from "./CardPayments.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__